import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { LegalsHeader } from '../legals-header/legals-header';

@Component({
  selector: 'app-terms-and-conditions',
  imports: [LegalsHeader, RouterLink],
  templateUrl: './terms-and-conditions.html',
})
export class TermsAndConditions {}
